import { render, staticRenderFns } from "./GoodTable.vue?vue&type=template&id=7d300da7&"
import script from "./GoodTable.vue?vue&type=script&lang=ts&"
export * from "./GoodTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports